












































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import ChannelPO from "@/store/entities/basedata/channelpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
@Component({
    components: { TreeSelect },
})
export default class CopyChannel extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    entity: ChannelPO = new ChannelPO();
    loading: boolean = false;
    created() {
        this.itemtree();
        this.entity.color = '#1961D2';
        this.entity.isEnable = 1;
    }
    create() {
        //console.log(this.list);
    }
    /**颜色变更 */
    changecolor(value: any) {
        //console.log(value)
        console.log(this.entity)
        this.entity.color = value;

    }
    save() {
        (this.$refs.areaForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                await this.$store.dispatch({
                    type: "channel/create",
                    data: this.entity,
                }).catch(() => {
                    this.loading = false;
                });
                this.loading = false;
                (this.$refs.areaForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.areaForm as any).resetFields();
        this.$emit("input", false);
    }
    async itemtree() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
        let infolist = detaillist.filter((p) => {
            return p.itemId == 29;
        });
        this.$data.optionsMechanism = [];
        //this.$data.optionsMechanism.push({ id: 0, title: '系统类型', children: [], expand: true });
        infolist.forEach((element) => {
            this.$data.optionsMechanism.push({ label: element.name, value: element.id });
        });
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.entity = Util.extend(
                true,
                {},
                this.$store.state.channel.editChannel
            );
            this.entity.name = "";
            this.$data.color = this.entity.color;
            delete this.entity.id;
        }
    }
    /**验证规则 */
    validaterule = {
        name: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        imageUrl: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        systemDetailId: [{
            type: "number",
            required: true,
            message: this.L("CanNotBeEmpty"),
            trigger: "blur",
        }],
        languageTag: [{
            required: true,
            message: this.L("CanNotBeEmpty"),
            trigger: "blur",
        }],
    };
    data() {
        return {
            optionsMechanism: [],
            color: '#1156DB',
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
}
